import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/poCss/purchaseOrder.css";
import { getpoData } from "../Api/ViewPostedInvoice";
import { Base_URL } from "../url";
import { useReactToPrint } from "react-to-print";
const { ToWords } = require("to-words");
const toWords = new ToWords({
  localeCode: "en-IN", // Indian format
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
  },
});

const PoPrintBody = ({ poData }) => {
  const componentRef = useRef();
  const location = useLocation();

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Invoice",
  });

  const invoiceId = location.pathname.split("/")[2];
  const [count, setCount] = useState("");

  // Safe conversion function for numbers
  const safeToFixed = (value, decimals = 2) => {
    if (value === null || value === undefined || isNaN(value)) {
      return "0.00";
    }
    return parseFloat(value).toFixed(decimals);
  };

  // Safe number conversion
  const safeNumber = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
      return 0;
    }
    return parseFloat(value);
  };

  const totalGSTWords = toWords
    .convert(
      safeNumber(poData?.invoiceSummary?.totalCGST) +
        safeNumber(poData?.invoiceSummary?.totalSGST) +
        safeNumber(poData?.invoiceSummary?.totalIGST),
      { currency: true }
    )
    .toUpperCase();

  console.log(poData, "poData");
  
  return (
    <div>
      {/* <!-- Products Table --> */}
      <table className="products-table">
        <thead>
          <tr>
            <th>SR. NO.</th>
            <th>PRODUCT DESCRIPTION</th>
            <th>HSN/SAC CODE</th>
            {/* <th>Batch Number</th> */}
            <th>MRP</th>
            {/* <th>Expiry Date</th> */}
            <th>QUANTITY</th>
            <th>UOM</th>
            {/* <th>BILLING RATE</th> */}
            <th> VALUE</th>
            {/* <th>DISC %</th>
            <th>DISCOUNT VALUE</th> */}
            {/* <th>TAXABLE VALUE</th> */}
            <th colspan="2">IGST</th>
            <th colspan="2">CGST</th>
            <th colspan="2">SGST</th>
            <th>Gross Value</th>
          </tr>
          <tr>
            <th></th>
           
            <th></th>
            <th></th>
            <th></th>
          
            
            
            <th></th>
            <th></th>
            <th></th>
            <th>RATE%</th>
            <th>AMOUNT</th>
            <th>RATE%</th>
            <th>AMOUNT</th>
            <th>RATE%</th>
            <th>AMOUNT</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {poData?.items?.length > 0 &&
            poData?.items.map((data, index) => {
              const price = safeNumber(data?.price);
              const quantity = safeNumber(data?.quantity);
              const basicValue = price * quantity;

              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{data?.description || "-"}</td>
                  <td>{data?.hsnId || "-"}</td>
                  {/* <td>{data?.batchId || "-"}</td> */}
                  <td>₹{safeToFixed(data?.price)}</td>
                  {/* <td>
                    {data?.expiryDate
                      ?.split("T")[0]
                      .split("-")
                      .reverse()
                      .join("-") || "-"}
                  </td> */}
                  <td>{data?.quantity || "0"}</td>
                  <td>{data?.unit || "-"}</td>
                  {/* <td>₹{safeToFixed(data?.price)}</td> */}
                  <td>₹{safeToFixed(data?.price*data?.quantity)}</td>
                  {/* <td>{safeToFixed(data?.discPercent)}</td>
                  <td>₹{safeToFixed(data?.discountValue)}</td> */}
                  {/* <td>₹{safeToFixed(data?.taxableValue)}</td> */}
                  <td>{data?.igstPercent || "0"}</td>
                  <td>₹{safeToFixed(data?.igstAmount)}</td>
                  <td>{data?.cgstPercent || "0"}</td>
                  <td>₹{safeToFixed(data?.cgstAmount)}</td>
                  <td>{data?.sgstPercent || "0"}</td>
                  <td>₹{safeToFixed(data?.sgstAmount)}</td>
                  <td>₹{safeToFixed(data?.grossValue)}</td>
                </tr>
              );
            })}
        </tbody>
      </table>

      {/* <!-- HSN Summary --> */}
      <div className="hsn-summary">
        <table className="hsn-table">
          <thead>
            <tr>
              <th>HSN WISE SUMMARY</th>
              <th>HSN CODE</th>
              <th>TAXABLE VALUE</th>
              <th>IGST RATE %</th>
              <th>IGST AMOUNT</th>
              <th>CGST RATE %</th>
              <th>CGST AMOUNT</th>
              <th>SGST/UT RATE %</th>
              <th>SGST/UT AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            {poData?.groupedItems?.length > 0 &&
              poData?.groupedItems.map((data, index) => {
                return (
                  <tr key={index}>
                    <td></td>
                    <td>{data?.hsnCode || "-"}</td>
                    <td>₹{safeToFixed(data?.totalTaxableValue)}</td>
                    <td>{data?.igstRate || "0"}</td>
                    <td>₹{safeToFixed(data?.totalIGST)}</td>
                    <td>{data?.cgstRate || "0"}</td>
                    <td>₹{safeToFixed(data?.totalCGST)}</td>
                    <td>{data?.sgstRate || "0"}</td>
                    <td>₹{safeToFixed(data?.totalSGST)}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      {/* <!-- Bottom Section --> */}
      <div className="bottom-section">
        <div className="payment-terms">
          <div className="total-words">
            <div>
              <strong>TOTAL GST PAYABLE (IN WORDS) : {totalGSTWords}</strong>
            </div>
            <br />
            <div>
              <strong>
                TOTAL NET PAYABLE (IN WORDS) :{" "}
                {toWords
                  .convert(
                    Math.round(
                      safeNumber(poData?.invoiceSummary?.totalamount)
                    )
                  )
                  .toUpperCase()}{" "}
                RUPEES AND ZERO PAISE ONLY
              </strong>
            </div>
          </div>
          <div>
            <h6>
              Notes:<p>{poData?.invoice?.subj_desc || "-"}</p>
            </h6>
          </div>
        </div>

        <div className="amount-summary">
          <div className="amount-row">
            <div className="amount-label">TAXABLE AMOUNT</div>
            <div className="amount-value">
              ₹{safeToFixed(poData?.invoiceSummary?.totalTaxableAmount)}
            </div>
          </div>
          <div className="amount-row">
            <div className="amount-label">CGST AMOUNT</div>
            <div className="amount-value">
              ₹{safeToFixed(poData?.invoiceSummary?.totalCGST)}
            </div>
          </div>
          <div className="amount-row">
            <div className="amount-label">SGST/UT AMOUNT</div>
            <div className="amount-value">
              ₹{safeToFixed(poData?.invoiceSummary?.totalSGST)}
            </div>
          </div>
          <div className="amount-row">
            <div className="amount-label">IGST AMOUNT</div>
            <div className="amount-value">
              ₹{safeToFixed(poData?.invoiceSummary?.totalIGST)}
            </div>
          </div>
          <div className="amount-row">
            <div className="amount-label">TOTAL AMOUNT</div>
            <div className="amount-value">
              ₹{safeToFixed(poData?.invoiceSummary?.totalamount)}
            </div>
          </div>
          <div className="amount-row">
            <div className="amount-label">Rounding off</div>
            <div className="amount-value">
              ₹{safeToFixed(poData?.invoiceSummary?.roundOffValue)}
            </div>
          </div>
          <div className="amount-row" style={{ background: "#f0f0f0" }}>
            <div className="amount-label">NET PAYABLE AMOUNT</div>
            <div className="amount-value" style={{ fontWeight: "bold" }}>
              ₹{safeToFixed(poData?.invoiceSummary?.totalamount)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoPrintBody;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../Styling/Invoice.css";
// import { getpoData } from "../Api/ViewPostedInvoice";
// import { Base_URL } from "../url";
// import { useReactToPrint } from "react-to-print";
// const { ToWords } = require("to-words");
// const toWords = new ToWords({
//   localeCode: "en-IN", // Indian format
//   converterOptions: {
//     currency: true,
//     ignoreDecimal: false,
//     ignoreZeroCurrency: false,
//     doNotAddOnly: false,
//   },
// });
// const InvoiceBody = ({ poData }) => {
//   const componentRef = useRef();
//   const toWords = new ToWords();
//   const location = useLocation();
//   const handlePrint = useReactToPrint({
//     contentRef: componentRef, // ✅ new API for v3+
//     documentTitle: "Invoice",
//   });

//   const invoiceId = location.pathname.split("/")[2];

//   console.log(invoiceId, "invoiceId");
//   // const [poData, setpoData] = useState({});
//   const [count, setCount] = useState("");
//   // useEffect(() => {
//   //   const fetchpoData = async () => {
//   //     const res = await getpoData(invoiceId);
//   //     console.log(res, 'res dngjf jhjkdt hjkt');
//   //     setpoData(res)
//   //     setCount(res?.items?.length)
//   //   }
//   //   fetchpoData()
//   // }, [])
//   const totalGSTWords = toWords
//     .convert(
//       Number(poData?.invoiceSummary?.totalCGST || 0) +
//         Number(poData?.invoiceSummary?.totalSGST || 0) +
//         Number(poData?.invoiceSummary?.totalIGST || 0),
//       { currency: true }
//     )
//     .toUpperCase();
//   console.log(poData, "poData");

//   return (
//     <div>
//       {/* <!-- Products Table --> */}
//       <table className="products-table">
//         <thead>
//           <tr>
//             <th>SR. NO.</th>
//             <th>PRODUCT DESCRIPTION</th>
//             <th>HSN/SAC CODE</th>
//             <th>Batch Number</th>
//             <th>MRP</th>
//             {/* <th>Batch Qty.</th>
//                 <th>MRP</th> */}
//             <th>Expiry Date</th>
//             <th>QUANTITY</th>
//             <th>UOM</th>
//             <th>BILLING RATE</th>
//             <th>BASIC VALUE</th>
//             <th>DISC %</th>
//             <th>DISCOUNT VALUE</th>
//             <th>TAXABLE VALUE</th>
//             <th colspan="2">IGST</th>
//             <th colspan="2">CGST</th>
//             <th colspan="2">SGST</th>
//             <th>Gross Value</th>
//           </tr>
//           <tr>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             {/* <th></th>
//                 <th></th> */}
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th>RATE%</th>
//             <th>AMOUNT</th>
//             <th>RATE%</th>
//             <th>AMOUNT</th>
//             <th>RATE%</th>
//             <th>AMOUNT</th>
//             <th></th>
//           </tr>
//         </thead>
//         <tbody>
//           {poData?.items?.length > 0 &&
//             poData?.items.map((data, index) => {
//               return (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{data?.itemName}</td>
//                   <td>{data?.hsn}</td>
//                   <td>{data?.batchId}</td>
//                   <td>{data?.batchLabel?.mrpInclGst.toFixed(2) || 0}</td>
//                   {/* <td>NULL</td>
//                     <td>NULL</td> */}
//                   <td>
//                     {data?.expiryDate
//                       ?.split("T")[0]
//                       .split("-")
//                       .reverse()
//                       .join("-")}
//                   </td>
//                   <td>{data?.quantity}</td>
//                   <td>{data?.unitCode}</td>
//                   <td>₹{data?.price}</td>
//                   <td>
//                     {`₹${
//                       parseFloat(data?.price || 0) *
//                       parseFloat(data?.quantity || 0)
//                     }`}
//                   </td>
//                   <td>{data?.discPercent.toFixed(2) || 0}</td>
//                   <td>₹{data?.discountValue.toFixed(2) || 0}</td>
//                   <td>₹{data?.taxableValue.toFixed(2) || 0}</td>
//                   {/* <td>{`₹${(parseFloat(data?.price || 0) *
//                      parseFloat(data?.quantity || 0)).toFixed(2) - parseFloat(data?.discountValue)}`}</td> */}

//                   <td>{data?.igst}</td>
//                   <td>
//                     ₹{parseFloat(data?.igstAmount.toFixed(2)) || 0}
//                   </td>
//                   <td>{data?.cgst}</td>
//                   <td>{data?.cgstAmount.toFixed(2) || 0}</td>
//                   <td>{data?.sgst}</td>
//                   <td>
//                     ₹{parseFloat(data?.sgstAmount.toFixed(2)) || 0}
//                   </td>

//                   <td>₹{data?.grossValue.toFixed(2) || 0}</td>
//                 </tr>
//               );
//             })}
//         </tbody>
//       </table>

//       {/* <!-- HSN Summary --> */}
//       <div className="hsn-summary">
//         <table className="hsn-table">
//           <thead>
//             <tr>
//               <th>HSN WISE SUMMARY</th>
//               <th>HSN CODE</th>
//               <th>TAXABLE VALUE</th>
//               <th>IGST RATE %</th>
//               <th>IGST AMOUNT</th>
//               <th>CGST RATE %</th>
//               <th>CGST AMOUNT</th>
//               <th>SGST/UT RATE %</th>
//               <th>SGST/UT AMOUNT</th>
//             </tr>
//           </thead>
//           <tbody>
//             {poData?.groupedItems?.length > 0 &&
//               poData?.groupedItems.map((data, index) => {
//                 return (
//                   <tr key={index}>
//                     <td></td>
//                     <td>{data?.hsnCode}</td>
//                     <td>{data?.totalTaxableValue.toFixed(2) || 0}</td>
//                     <td>{data?.igstRate}</td>
//                     <td>{data?.totalIGST.toFixed(2) || 0}</td>
//                     <td>{data?.cgstRate}</td>
//                     <td>{data?.totalCGST.toFixed(2) || 0}</td>
//                     <td>{data?.sgstRate}</td>
//                     <td>{data?.totalSGST.toFixed(2) || 0}</td>
//                   </tr>
//                 );
//               })}
//           </tbody>
//         </table>
//       </div>

//       {/* <!-- Bottom Section --> */}
//       <div className="bottom-section">
//         <div className="payment-terms">
//           {/* <div style={{ marginBottom: "10px" }}><strong>IRN NO. :</strong></div> */}

//           <div className="total-words">
//             <div>
//               <strong>
//                 TOTAL GST PAYABLE (IN WORDS) : {totalGSTWords}
//                 {/* {toWords.convert(poData?.invoiceSummary?.totalamount)} */}
//                 {/* {toWords.convert(poData?.invoiceSummary?.totalamount);} */}
//               </strong>
//             </div>
//             <br />
//             <div>
//               <strong>
//                 TOTAL NET PAYABLE (IN WORDS) :{" "}
//                 {toWords
//                   .convert(
//                     Math.round(
//                       Number(poData?.invoiceSummary?.totalamount ?? 0)
//                     )
//                   )
//                   .toUpperCase()}{" "}
//                 RUPEES AND ZERO PAISE ONLY
//               </strong>
//             </div>
//           </div>
//           <div>
//             <h6>
//               Notes:<p>{poData?.invoice?.subj_desc}</p>
//             </h6>
//           </div>
//         </div>

//         <div className="amount-summary">
//           <div className="amount-row">
//             <div className="amount-label">TAXABLE AMOUNT</div>
//             <div className="amount-value">
//               {poData?.invoiceSummary?.totalTaxableAmount}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">CGST AMOUNT</div>
//             <div className="amount-value">
//               {poData?.invoiceSummary?.totalCGST.toFixed(2) || 0}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">SGST/UT AMOUNT</div>
//             <div className="amount-value">
//               {poData?.invoiceSummary?.totalSGST.toFixed(2) || 0}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">IGST AMOUNT</div>
//             <div className="amount-value">
//               {poData?.invoiceSummary?.totalIGST.toFixed(2) || 0}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">TOTAL AMOUNT</div>
//             <div className="amount-value">
//               {poData?.invoiceSummary?.totalamount.toFixed(2) || 0}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">Rounding off</div>
//             <div className="amount-value">
//               {poData?.invoiceSummary?.roundOffValue}
//             </div>
//           </div>
//           <div className="amount-row" style={{ background: "#f0f0f0" }}>
//             <div className="amount-label">NET PAYABLE AMOUNT</div>
//             <div className="amount-value" style={{ fontWeight: "bold" }}>
//               {poData?.invoiceSummary?.totalamount.toFixed(2) ?? 0}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* terms conetent start */}
//     </div>
//   );
// };
// export default InvoiceBody;
